import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';
import { kioskApi } from '../lib/kiosk-api.js';

export function KioskDocList({ session, onOpen }) {
  const locKey = session.location.key;
  const [docs, setDocs] = useState([]);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  useEffect(() => {
    setLoading(true);
    kioskApi('GET', `/api/kiosk/${locKey}/knowledge-docs`, null, session.token)
      .then(r => setDocs(r.docs || []))
      .catch(e => setErr(e.message || String(e)))
      .finally(() => setLoading(false));
  }, []);
  const q = query.trim().toLowerCase();
  const filtered = q ? docs.filter(d => (d.title || '').toLowerCase().includes(q) || (d.category || '').toLowerCase().includes(q)) : docs;
  const byCategory = {};
  for (const d of filtered) {
    const cat = d.category || 'Uncategorized';
    (byCategory[cat] = byCategory[cat] || []).push(d);
  }
  if (loading) return <div style={{ fontSize: 13, color: '#9e9e9e' }}>Loading…</div>;
  if (err) return <div style={{ background: '#fee', padding: 12, borderRadius: 8, color: '#b91c1c', fontSize: 13 }}>{err}</div>;
  return (
    <div>
      <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search policies & SOPs…"
        style={{ width: '100%', padding: '10px 12px', fontSize: 14, border: '1px solid #d0d4d9', borderRadius: 8, marginBottom: 10, fontFamily: 'inherit' }} />
      {filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 24, color: '#9e9e9e', fontSize: 13 }}>No documents found.</div>
      ) : Object.keys(byCategory).sort().map(cat => (
        <div key={cat} style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 11, color: '#9e9e9e', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 700, marginBottom: 6 }}>{cat}</div>
          <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e0e0e0', overflow: 'hidden' }}>
            {byCategory[cat].map(d => (
              <button key={d.id} onClick={() => onOpen(d.id)}
                style={{ display: 'block', width: '100%', textAlign: 'left',
                          padding: '12px 14px', borderBottom: '1px solid #f5f5f5',
                          background: '#fff', border: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#212121' }}>{d.title}</div>
                {d.type && <div style={{ fontSize: 11, color: '#9e9e9e', marginTop: 2, textTransform: 'capitalize' }}>{d.type.replace(/_/g, ' ')}</div>}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
